export default function (data) {
  let item = {
    col: data.ItemsPerPage,
    type: data.ViewType,
    columns: [],
    data: data,
  };
  data.ItemsLegend.forEach(i => {
    if (!i.CanVisible) return;
    let name = i.FieldName;
    if (i.ArrayName != null && i.ArrayName != undefined && i.ArrayName != ''){
      name = (i.ArrayName + '_' + name);
    }
    item.columns.push({
      type: i.Type ? i.Type : 'text',
      name: name,
      fixed: i.IsFixed,
      visible: i.IsVisible,
      width: i.ColumnWidth,
      label: i.Name,
      index: i.ColumnIndex,
      id: i.FieldName + i.ColumnIndex,
      data: i,
    });
  });
  data.CustomSettings.forEach(i => {
    if (i.Name === 'filters') item.filters = JSON.parse(i.Value);
    if (i.Name === 'height') item.height = +JSON.parse(i.Value);
    if (i.Name === 'heightFixed') item.heightFixed = JSON.parse(i.Value);
    if (i.Name === 'search') item.search = JSON.parse(i.Value);
    if (i.Name === 'defaultFilter') item.defaultFilter = JSON.parse(i.Value);
    if (i.Name === 'opened') item.opened = JSON.parse(i.Value);
    if (i.Name === 'reopenPayToAgreement') item.reopenPayToAgreement = JSON.parse(i.Value);
  });
  if (typeof item.filters === 'undefined') item.filters = [];
  if (typeof item.height === 'undefined') item.height = 400;
  if (typeof item.heightFixed === 'undefined') item.heightFixed = false;
  if (typeof item.search === 'undefined') item.search = true;
  if (typeof item.opened === 'undefined') item.opened = {};
  return item
}